declare namespace $ {

	export class $shm_echarts extends $mol_view {
		option( ): any
		dom_name( ): string
		option_themed( ): ReturnType< $shm_echarts['option'] >
		animation_duration_initial( ): number
		animation_duration_update( ): number
		animation_easing( ): string
		lights( ): boolean
		click( next?: any ): any
		brush_end( next?: any ): any
		finished( next?: any ): any
		brush_cursor( ): any
		grid_rect( ): ({ 
			'x': number,
			'y': number,
			'width': number,
			'height': number,
		}) 
		sub( ): any
	}
	
}

//# sourceMappingURL=echarts.view.tree.d.ts.map